import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b95fd882&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b95fd882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95fd882",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b95fd882')) {
      api.createRecord('b95fd882', component.options)
    } else {
      api.reload('b95fd882', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b95fd882&scoped=true&", function () {
      api.rerender('b95fd882', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/purchase/index.vue"
export default component.exports